export default __webpack_public_path__ + "static/media/bambino-baby-cabbage-roasted-with-lemon.39cf99a2.png";